import { Cookie } from 'lucide-react';
import LegalDocument from '@/components/LegalDocument';

export default function Cookies() {
  return <LegalDocument docKey="cookies_doc" icon={Cookie} />;
}
